import React, { Fragment } from 'react';

import autobind from 'autobind-decorator';
import ListCarousel from './list-carousel';

class ArtistsListSection extends React.Component {
	constructor (props) {
		super(props);
		this.state = {showArrows: false};
	}


	render() {
		const { sectionLabel, artists, mode } = this.props;
		const responsiveBreakpoints = {
			desktop: {
			  breakpoint: { max: 3000, min: 1024 },
			  items: 5,
			  slidesToSlide: 2,
			  partialVisibilityGutter: 40
			},
			tablet: {
			  breakpoint: { max: 1024, min: 464 },
			  items: 5,
			  slidesToSlide: 5,
			  partialVisibilityGutter: 40
			},
			mobile: {
			  breakpoint: { max: 464, min: 0 },
			  items: 5,
			  slidesToSlide: 3,
			  partialVisibilityGutter: 40
			},
		};

		if (artists.length === 0) {
			return (
				<Fragment>
					<div className="grid-x grid-padding-x padding-bottom-2">
						<div className="cell">
							<h3 className="section-title padding-bottom-1">{ sectionLabel }</h3>
						</div>
					</div>

					<div className="grid-x grid-padding-x padding-bottom-2">
						<div className="cell"><p>No artists to display</p></div>
					</div>
				</Fragment>
			);
		}

		return (
			<Fragment>
				<div className="grid-x">
					<div className="cell">
						<h3 className="section-title" style={{'marginBottom': '0vh'}}>{ sectionLabel }</h3>
					</div>
				</div>
					<div
						className={this.state.showArrows ? 'list-section-hover' : 'list-section-unhover'}
						onMouseEnter={this.mouseIn}
						onMouseLeave={this.mouseOut}
					>
						<ListCarousel artists={artists} hideFunc={this.props.hideFunc} responsiveBreakpoints={responsiveBreakpoints}/>
					</div>
			</Fragment>
		);
	}

	@autobind
	mouseIn () {
		this.setState({showArrows: true});
	}

	@autobind
	mouseOut () {
		this.setState({showArrows: false});
	}

}

export default ArtistsListSection;
